import knex from 'knex';
import { devError, devLog } from '../log';

const client = 'mssql';
const server = `${process.env.DEFAULT_DATABASE_HOST}`; // renamed from host for tedious >=17
const user = `${process.env.DEFAULT_DATABASE_USER}`;
const password = `${process.env.DEFAULT_DATABASE_PASS}`;
const database = `${process.env.DEFAULT_DATABASE_NAME}`;
const requestTimeout = 300000; // 5 minutes timeout for Azure
const options = {
  encrypt: false, // SQL Server Standard on VM doesn't require encryption
  enableArithAbort: true,
  trustServerCertificate: true, // Trust self-signed certificates on VM
  connectionTimeout: 30000,
  requestTimeout: 300000,
};

const connection = {
  server,
  user,
  password,
  database,
  options,
};

const debug = process.env.NODE_ENV === 'development';
const log = debug
  ? {
      error(message) {
        devError('Knex Error:', message);
      },
      debug(message) {
        devLog('Knex Debug:', message);
      },
    }
  : {};

const acquireConnectionTimeout = 600000;

const DBConnection = {
  log,
  debug,
  client,
  connection,
  acquireConnectionTimeout,
  pool: {
    min: 2,
    max: 50,
  },
};

export const sqlConnection = knex(DBConnection);
